import { render, staticRenderFns } from "./PowerdataAlerts.vue?vue&type=template&id=0241ce50"
import script from "./PowerdataAlerts.vue?vue&type=script&lang=js"
export * from "./PowerdataAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports